import React from 'react';
export function DescriptionSection() {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 md:p-10 mb-12" data-id="element-1825">
      <div className="max-w-4xl mx-auto space-y-6 text-gray-700 text-lg leading-relaxed" data-id="element-1826">
        <p data-id="element-1827">
          High-precision EDM drilling machines for creating small, deep holes in
          conductive materials. Available in economical ZNC configurations from
          EDMMax, CHMER ZNC series (H32Z through H75Z), and full CNC H series
          with linear motor drives (H32C, H64CL, H86CL, H1080CL). Widely used in
          aerospace, medical, and tooling applications.
        </p>
      </div>
    </div>;
}